import { Component, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular-legacy';
import { ICellRendererParams } from 'ag-grid-community';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuoteService } from '../../services/quote.service'
import { HelperService } from '../../services/helper.service';

@Component({
  selector: 'app-custom-button-cellrender',
  templateUrl: './custom-button-cellrender.component.html',
  styleUrls: ['./custom-button-cellrender.component.css']
})

export class CustomButtonCellrenderComponent implements ICellRendererAngularComp {
  public acceptedPaymentsColumnDefs: any = [
    {
      headerName: 'Payment number', field: 'bcfObligationNumber', sortable: true, filter: 'agTextColumnFilter', minWidth: 100
    },
    {
      headerName: 'RTMP Submitted date', valueFormatter: params => this.helperService.dateFormat(params.data.dateCreated,"DD/MM/yyyy"),
      sortable: true, filter: 'agTextColumnFilter', minWidth: 175
    },
    {
      headerName: 'No. Of BAM credits', field: 'credit.totalCredits', sortable: true, filter: 'agTextColumnFilter', minWidth: 100 
    }
  ];
  params!: ICellRendererParams;
  modalReference: any;
  obligation: any = null;
  acceptedObligations: any[];
  @ViewChild('accptedPayments', { static: false }) acceptedPaymentsModal: TemplateRef<any>;

  constructor(private modalService: NgbModal, private quoteService: QuoteService,
    private activeRoute: ActivatedRoute, private helperService: HelperService) {
  }

  agInit(params: any): void {
   this.params = params;
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  viewPayments($event) {
    this.obligation = this.params.data;
    const id = Number(this.activeRoute.snapshot.paramMap.get('id'));

    if (!isNaN(id) && id > 0) {
      this.loadAcceptedObligations(id);
    }
    
  }

  private loadAcceptedObligations(id: number) {
    this.quoteService.getAcceptedObligations(id).subscribe(result => {
      this.acceptedObligations = result != null ? result.filter(r =>
        r.credit.creditTypeId == this.obligation.creditTypeId &&
        r.credit.creditCategory == this.obligation.creditCategory
      ) : [];
      this.modalReference = this.modalService.open(this.acceptedPaymentsModal, { ariaLabelledBy: 'modal-basic-title', size: 'xl', backdrop: 'static' });
    
    });
  }

  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
  }
}
